import { FieldParams } from "../../core/FieldObject";
import { PostJson } from "../../core/Helper";
import { FieldDataType, FormControlType } from "../../core/Helper2";

export const DocuBranchObj = {
  DocuBrchId: {
    ...new FieldParams(
      "DocuBrchId",
      "DocuBrchId",
      true,
      FieldDataType.NUMERIC,
      FormControlType.HIDDEN
    ),
    isHiddenColumn: true,
  },
  Branch: { ...new FieldParams("Branch", "Branch") },
  DocuType: { ...new FieldParams("DocuType", "DocuType") },
};

export const GetDocuRunningFormat = (bDoc) => {
  let lastNum = Number(bDoc.RunningNo) + 1;
  let zero = "";
  for (let index = 0; index < bDoc.BranchDocu.DocuType.RunningDigits; index++) {
    zero += "0";
  }
  zero += lastNum;
  zero =
    (bDoc.BranchDocu.DocuType.RunningPrefix ?? "") +
    bDoc.PeriodText +
    zero.substring(zero.length - bDoc.BranchDocu.DocuType.RunningDigits);
  return zero;
};

export class BranchDocuService {
  static async GetRunningNumber(data, user) {
    let result = await PostJson("api/docu-branch/get-run-number", {
      data,
      user,
    });
    return result ?? null;
  }

  static async GetList(data, user) {
    let result = await PostJson("/api/docu-branch/getlist", {
      data,
      user,
    });
    return result ?? null;
  }
  static async SaveItem(data, user) {
    let result = await PostJson("/api/docu-branch/update", {
      data,
      user,
    });
    return result ?? null;
  }

  static async DeleteItem(data, user) {
    let result = await PostJson("/api/docu-branch/delete", {
      data,
      user,
    });
    return result ?? null;
  }
}
